/**
 * @component {"type":"AdditionalImages","version":"1.1"}
 * @component {"type":"SVGWithText","version":"1.0"}
 */

define('entity',['knockout', 'knockout-mapping', 'helpers', 'training'], function(ko, mapping, helpers, Training) {
    'use strict';

    return function(viewModel, dataContext) {
        var self = this,
            current = dataContext.learning.current,
            training = new Training(),
            trainingData,
            containerID;

        if (!dataContext.learning || !dataContext.learning.current) {
            return;
        }

        trainingData = dataContext.learning.training;

        containerID = trainingData.contentContainerId;

        /* TMP while trainingVM after entityVM in VM */
        self.trainingComponentsJSON = ko.computed(function () {
            var componentsJson = trainingData.componentsJson;
            return (componentsJson) ? JSON.parse(componentsJson) : [];
        });

        self.trainingAdditionalImages = ko.computed(function() {
            var imagesAdditional,
                componentsJSON = self.trainingComponentsJSON();

            if (!componentsJSON.length) {
                return [];
            }

            imagesAdditional = helpers.component.getContent(componentsJSON, 'AdditionalImages');

            return helpers.component.parseProp(imagesAdditional, 'images', 'ImageWithId');
        });
        /* TMP END while trainingVM after layoutVM in VM */

        self.ID = ko.observable(current.ID);
        self.name = ko.observable(current.name);
        self.title = ko.observable(current.title);

        self.pageTitle = ko.computed(function() {
            return self.title() || self.name();
        });

        self.typeId = ko.observable(current.typeId);
        self.displayMode = ko.observable(current.displayMode);

        self.displayType = ko.computed(function() {
           switch (self.displayMode()) {
               case 2:
                   return "radio";
               case 6:
                   return "slider";
               case 7:
                   return "stars"
               default:
                   return "";
           }
        });

        self.dateModified = ko.observable(current.dateModified);

        self.parentId = ko.observable(current.parentId);
        self.parentID = ko.computed(function() {
            return self.parentId();
        });

        self.parents  = ko.computed(function() {
            var ID = self.parentID(),
                arr = [],
                entity = null;

            while (ID) {
                entity = training.getEntity(ID);

                if (entity === null) {
                    return arr.reverse();
                }

                arr.push(entity.contentEntity.title || entity.contentEntity.name);
                ID = entity.contentEntity.parentId || '';
            }

            return arr.reverse();
        });

        self.content = ko.observable(current.content);
        self.text = ko.observable(current.text);

        self.naviTargetId = ko.observable(current.naviTargetId);
        self.maximumWords = ko.observable(current.maximumWords);

        self.children = mapping.fromJS(current.children, self);

        self.freeTextAnswerId = ko.observable(current.freeTextAnswerId);
        self.showDontKnowOption = ko.observable(current.showDontKnowOption);
        self.leftColumnTitle = ko.observable(current.leftColumnTitle);
        self.rightColumnTitle = ko.observable(current.rightColumnTitle);

        self.passAlways = ko.observable(current.passAlways);
        self.passThreshold = ko.observable(current.passThreshold);
        self.passedFeedback = ko.observable(current.passedFeedback);
        self.failedFeedback = ko.observable(current.failedFeedback);
        self.enableMovingBackwards = ko.observable(current.enableMovingBackwards);
        self.completeDespiteResults = ko.observable(current.completeDespiteResults);
        self.requiresCompletion = ko.observable(current.requiresCompletion);

        self.taskCountToAsk = ko.observable(current.taskCountToAsk);
        self.taskCountToShow = ko.observable(current.taskCountToShow);

        self.canSubmitMultipleTimes = ko.observable(current.canSubmitMultipleTimes);
        self.requiresAnswer = ko.observable(current.requiresAnswer);
        self.hasCorrectAnswers = ko.observable(current.hasCorrectAnswers);

        self.correctAnswerFeedbackId = ko.observable(current.correctAnswerFeedbackId);
        self.incorrectAnswerFeedbackId = ko.observable(current.incorrectAnswerFeedbackId);

        self.answerScoreCaption = ko.observable(current.answerScoreCaption);
        self.answerNoOpinionCaption = ko.observable(current.answerNoOpinionCaption);

        self.componentsJson = ko.observable(current.componentsJson);
        self.componentsJSON = ko.computed(function() {
            var str = self.componentsJson();

            return training.parseComponents(str);
        }).extend({notify: 'always'});

        self.commentsCount = ko.observable('-');

        ko.computed(function() {
            var promise = dataContext.fetchCommentsCount(self.ID());

            self.commentsCount('-');

            promise.then(function(count){
                self.commentsCount(count);
            });
        });

        self.customCss = ko.observable(current.customCss);
        self.customCSS = ko.computed(function() {
            return (self.customCss()) ? self.customCss() : '';
        }).extend({notify: 'always'});

        self.customUiTemplates = ko.observable(current.customUiTemplates);
        self.customHTML = ko.computed(function() {
            return (self.customUiTemplates()) ? self.customUiTemplates() : '';
        }).extend({notify: 'always'});

        self.customJavascript = ko.observable(current.customJavascript);
        self.customJS = ko.computed(function() {
            return (self.customJavascript()) ? self.customJavascript() : '';
        }).extend({notify: 'always'});

        self.imageID = ko.observable(current.imageID);

        self.imageURL = ko.computed(function() {
            var imageID = self.imageID();

            return training.getMediaURL(imageID);
        });

        self.backgroundImageURL = ko.computed(function() {
            return 'url("' + self.imageURL() + '")';
        });

        self.imageContentType = ko.computed(function() {
            var imageID = self.imageID();

            return training.getMediaContentType(imageID);
        });

        self.getComponentsByKind = function(kind) {
            return helpers.content.componentObject.getComponentsByKind(self, kind);
        };

        self.showTextAreaBackground = ko.observable(current.showTextAreaBackground);

        self.imageScaleMode = ko.observable(current.imageScaleMode);
        self.imageScaleSize = ko.computed(function() {
            var trainingMode = trainingData.imageScaleMode,
                mode = self.imageScaleMode();

            switch(mode) {
                case 0:
                    return (trainingMode === 1) ? 'contain' : 'cover';
                case 1:
                    return 'cover';
                case 2:
                    return 'contain';
                case 3:
                    return '100% 100%';
                default:
            }

            return 'contain';
        });

        self.imagePosition = ko.observable(current.imagePosition);
        self.imagePositionCSS = ko.computed(function() {
            var position = self.imagePosition();

            if (!position || position === 0) {
                position = trainingData.imagePosition;
            }

            if (!position || position === 0) {
                return '';
            }

            switch(position) {
                case 1:
                    return '0 0';
                case 2:
                    return '0 50%';
                case 3:
                    return '0 100%';
                case 4:
                    return '50% 0';
                case 5:
                    return '50% 50%';
                case 6:
                    return '50% 100%';
                case 7:
                    return '100% 0';
                case 8:
                    return '100% 50%';
                case 9:
                    return '100% 100%';
                default:
                    return '50% 50%';
            }
        });

        self.answers = mapping.fromJS(current.answers, self);
        self.answersJS = ko.computed(function() {
            var ID = self.ID(),
                entity = training.getEntity(ID);

            return (Array.isArray(entity.answers)) ? entity.answers : [];
        });

        self.questions = mapping.fromJS(current.questions, self);
        self.questionsJS = ko.computed(function() {
            var ID = self.ID(),
                entity = training.getEntity(ID);

            return (Array.isArray(entity.questions)) ? entity.questions : [];
        });

        self.feedbacks = mapping.fromJS(current.feedbacks, self);
        self.components = mapping.fromJS(current.components, self);
        self.childrens = mapping.fromJS(current.childrens, self);

        self.componentHTML = ko.observable('');
        self.componentHTML2 = ko.observable('');

        self.entityContent = ko.computed(function() {
            var ID = self.ID(),
                content = training.getContent(ID),
                imagesAdditional = helpers.component.getContent(content.componentsJSON, 'AdditionalImages'),
                additionalImages = helpers.component.parseProp(imagesAdditional, 'images', 'ImageWithId'),
                svgWithText = helpers.component.getContent(content.componentsJSON, 'SVGWithText'),
                svgWithTextImages = [],
                customComponent = helpers.component.getContent(content.componentsJSON, 'CustomComponent'),
                customComponentImages = helpers.component.parseProp(customComponent, 'images', 'ImageWithId'),
                customComponent2 = helpers.component.getContent(content.componentsJSON, 'CustomComponent2'),
                customComponentImages2 = helpers.component.parseProp(customComponent2, 'images', 'ImageWithId'),
                hotspots = helpers.component.getContent(content.componentsJSON, 'Hotspots'),
                componentImages = [],
                parseMediaURL = function(arr) {
                    if (!Array.isArray(arr) || !arr.length) {
                        return [];
                    }

                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i].source) {
                            arr[i].source = training.parseMediaURL(arr[i].source)
                        }
                        if (arr[i].image) {
                            arr[i].source = training.parseMediaURL(arr[i].image)
                        }
                    }

                    return arr;
                };

            dataContext.watch(ID);

            if (Object.keys(svgWithText).length) {
                if (Array.isArray(svgWithText.id)) {
                    for (var i = 0; i < svgWithText.id.length; i++) {
                        var svtTextObj = {};

                        svtTextObj.id = svgWithText.id[i];
                        svtTextObj.image = svgWithText.image[i];
                        svtTextObj.items = svgWithText.items[i];
                        svtTextObj.origin = svgWithText.origin[i];

                        svgWithTextImages.push(svtTextObj);
                    }
                } else {
                    svgWithTextImages.push(svgWithText);
                }
            }

            return {
                ID: ID,
                dateModified: content.dateModified,
                displayMode: content.displayMode,
                imageURL: content.imageURL,
                typeID: content.typeId,
                imageContentType: content.imageContentType,
                componentsJSON: content.componentsJSON,
                customCSS: content.customCSS,
                customHTML: content.customHTML,
                customJS: content.customJS,

                componentCSS: (customComponent && customComponent.hasOwnProperty('css') && customComponent.css) ? customComponent.css : '',
                componentHTML: (customComponent && customComponent.hasOwnProperty('html') && customComponent.html) ? customComponent.html : '',
                componentJS: (customComponent && customComponent.hasOwnProperty('javaScript') && customComponent.javaScript) ? customComponent.javaScript : '',
                componentCSS2: (customComponent2 && customComponent2.hasOwnProperty('css') && customComponent2.css) ? customComponent2.css : '',
                componentHTML2: (customComponent2 && customComponent2.hasOwnProperty('html') && customComponent2.html) ? customComponent2.html : '',
                componentJS2: (customComponent2 && customComponent2.hasOwnProperty('javaScript') && customComponent2.javaScript) ? customComponent2.javaScript : '',
                componentImages: componentImages.concat(parseMediaURL(customComponentImages)).concat(parseMediaURL(customComponentImages2)).concat(parseMediaURL(additionalImages)).concat(parseMediaURL(self.trainingAdditionalImages())).concat(parseMediaURL(svgWithTextImages)),
                hotspotsImageURL: (hotspots && hotspots.backgroundImage) ? training.parseMediaURL(hotspots.backgroundImage) : '',
                hotspotsImageContentType: (hotspots && hotspots.backgroundImage) ? training.parseMediaContentType(hotspots.backgroundImage) : ''
            };
        });

        self.typeID = ko.computed(function() {
            return self.typeId();
        }).extend({notify: 'always'});

        self.isTaskPage = function() {
            return (self.answersJS().length > 0 || self.questionsJS().length > 0);
        };

        self.isQuizPage = function() {
            var entity = training.getEntity(self.ID());

            return (entity !== null && entity.typeId === 19) ? true : false;
        };

        self.isQuizTask = function() {
            var ID      = self.parentId(),
                entity  = null,
                checkParent = function(ID) {
                    entity = training.getEntity(ID);

                    if (entity !== null) {
                        if (entity.typeId === 19) {
                            return true;
                        } else if (ID === containerID) {
                            return false;
                        } else {
                            return checkParent(entity.contentEntity.parentId);
                        }
                    }

                };

            return (self.isQuizPage() || ID === containerID) ? false : checkParent(ID);
        };

        self.containsStatistics = ko.computed(function() {
            var content = helpers.component.getContent(self.componentsJSON(), 'Statistics'),
                displayMode = self.displayMode();

            if (!Object.keys(content).length) {
                return false;
            }

            switch(self.typeID()) {
            case 12:
                return true;
            case 13:
                return true;
            case 14:
                if (displayMode === 2) {
                    return true;
                }
                return false;
            default:
                return false;
            }
        }).extend({rateLimit: 0});

        self.isModularNavigation = ko.observable('');

        self.isQuizGame = function() {
            var ID = self.ID(),
                game = helpers.content.getQuizGame(ID, trainingData.contentEntities);

            return (game.isQuizGame) ? true : false;
        };

	};

});

